import { ContributorType } from "@/src/types";
import React from "react";
import ContributorCard from "../cards/ContributorCard";
import SmallContributorCard from "../cards/SmallContributorCard";

export interface AuthorObject {
  avatar: {
    url: string;
  };
  id: string;
  name: string;
  nicename: null;
  nickname: null;
  slug: string;
  uri: string;
}

const Contributors = ({
  contributors,
}: {
  contributors: ContributorType[];
}) => {
  return (
    <div className="flex gap-2 flex-col lg:flex-row">
      {contributors.map(function (contributor, index) {
        return (
          <SmallContributorCard
            key={`contributor-${index}`}
            contributor={contributor}
            hasElevation={false}
            transparent
          />
        );
      })}
    </div>
  );
};

export default Contributors;
